import Cookies from 'js-cookie';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';
import Cookie from '../../const/Cookie';

export function execute(keepLoggedUser) {
  if (!keepLoggedUser) {
    const callcenterLoginData = Cookies.get(Cookie.CALLCENTER_LOGIN_DATA_KEY);
    if (callcenterLoginData) {
      Cookies.remove(Cookie.CALLCENTER_LOGIN_DATA_KEY);
      EventEmitter.emitEvent(Listener.UPDATE_HEADER);
    }
  }
}



// WEBPACK FOOTER //
// ./src/usecases/loggedUserCallcenter/LoggedUserCallcenterUC.js